export default __webpack_public_path__ + "static/media/1519.5d233bd3.png";